import { useCallback, useRef } from 'react';
import { useMouseMetrics } from "../useMouseMetrics";
/**
 * This hook indicates when the user is deliberately attempting to interact with an
 * an element. This is currently a relatively naive velocity based approach (i.e., if the
 * cursor appears over an element with a slow enough speed, assume it's going to be
 * clicked).
 *
 * @usage
 * const [isHovering, setIsHovering] = useState(false);
 * const { bind } = useHoverIntent(() => setIsHovering(true), {
 * velocity: 0.2
 * });
 *
 * return <button {...bind}>{isHovering ? 'hovering' : 'not hovering'}</button>;
 */

export function useHoverIntent(onHoverIntent) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
    velocity: 0.07
  };
  var threshold = options.velocity;
  var hasShownIntent = useRef(false);
  var onMouseMove = useCallback(function (_ref) {
    var velocity = _ref.velocity;

    if (velocity < threshold && !hasShownIntent.current) {
      onHoverIntent();
      hasShownIntent.current = true;
    }
  }, [onHoverIntent, threshold]);
  var onMouseLeave = useCallback(function () {
    hasShownIntent.current = false;
  }, []);
  return useMouseMetrics({
    onMouseMove: onMouseMove,
    onMouseLeave: onMouseLeave
  });
}